import { Model } from '@vuex-orm/core'
import ArticlesHasAccessorygroup from '@models/helpers/ArticlesHasAccessorygroup'

export default class Accessorygroup extends Model{
  static entity = 'accessorygroups'
  static fields () {
    return {
      id: this.attr(null),
      description: this.attr(null),
      group_level: this.attr(null),
      label: this.attr(null),
      parent_group_id: this.attr(null),
      picture: this.attr(null),
      sort_index: this.attr(null),
      articles: this.hasMany(ArticlesHasAccessorygroup, 'accessorygroups_id'),
    }
  }
}
  